export default {}



//////////////////
// WEBPACK FOOTER
// ./mockdatas/mockdata.js
// module id = 78
// module chunks = 1